import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/MyCourse',
        meta: {
            title: '我的课程'
        }
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('../views/Login/Login.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/MyCourse',
        name: 'MyCourse',
        component: () => import('../views/MyCourse/MyCourse.vue'),
        meta: {
            title: '我的课程'
        }
    },
    {
        path: '/PlayVideo',
        name: 'PlayVideo',
        component: () => import('../views/MyCourse/PlayVideo.vue'),
        meta: {login_require: true, title: '我的视频'}

    },
    {
        path: '/CourseMessage',
        name: 'CourseMessage',
        component: () => import('../views/MyCourse/CourseMessage.vue'),
        meta: {
            title: '暂无课程'
        }
    },
    {
        path: '/MyQuestion',
        name: 'MyQuestion',
        component: () => import('../views/MyQuestion/MyQuestion.vue'),
        meta: {
            title: '我的题库'
        }
    },
    {
        path: '/AnswerExercises',
        name: 'AnswerExercises',
        component: () => import('../views/MyQuestion/AnswerExercises.vue'),
        meta: {
            title: '答题练习'
        }
    },
    {
        path: '/AnswerSheet',
        name: 'AnswerSheet',
        component: () => import('../views/MyQuestion/AnswerSheet.vue'),
        meta: {
            title: '答题卡'
        }
    },
    {
        path: '/AnswerReport',
        name: 'AnswerReport',
        component: () => import('../views/MyQuestion/AnswerReport.vue'),
        meta: {
            title: '错题报告'
        }
    },
    {
        path: '/QuestionMessage',
        name: 'QuestionMessage',
        component: () => import('../views/MyQuestion/QuestionMessage.vue'),
        meta: {
            title: '暂无题库'
        }
    },
    {
        path: '/MyWrongTopic',
        name: 'MyWrongTopic',
        component: () => import('../views/MyWrongTopic/MyWrongTopic.vue'),
        meta: {
            title: '我的错题'
        }
    },
    {
        path: '/ErrQuestion',
        name: 'ErrQuestion',
        component: () => import('../views/MyWrongTopic/ErrQuestion.vue'),
        meta: {
            title: '错题信息'
        }
    },
    {
        path: '/WrongTopicMessage',
        name: 'WrongTopicMessage',
        component: () => import('../views/MyWrongTopic/WrongTopicMessage.vue'),
        meta: {
            title: '暂无错题'
        }
    },
    {
        path: '/StudentInfo',
        name: 'StudentInfo',
        component: () => import('../views/MyInfo/StudentInfo.vue'),
        meta: {
            title: '我的报考信息'
        }
    }
];

const router = new VueRouter({
    routes
});

export default router
